/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const OAuthGrants = {
    authorization_code: 'authorization_code',
    refresh_token: 'refresh_token'
} as const;
export type OAuthGrants = typeof OAuthGrants[keyof typeof OAuthGrants];


export function instanceOfOAuthGrants(value: any): boolean {
    for (const key in OAuthGrants) {
        if (Object.prototype.hasOwnProperty.call(OAuthGrants, key)) {
            if (OAuthGrants[key as keyof typeof OAuthGrants] === value) {
                return true;
            }
        }
    }
    return false;
}

export function OAuthGrantsFromJSON(json: any): OAuthGrants {
    return OAuthGrantsFromJSONTyped(json, false);
}

export function OAuthGrantsFromJSONTyped(json: any, ignoreDiscriminator: boolean): OAuthGrants {
    return json as OAuthGrants;
}

export function OAuthGrantsToJSON(value?: OAuthGrants | null): any {
    return value as any;
}

export function OAuthGrantsToJSONTyped(value: any, ignoreDiscriminator: boolean): OAuthGrants {
    return value as OAuthGrants;
}

